import { useCallback, useMemo, useState } from "react"
import { format } from "date-fns"

/**
 * Shared day-picker state for the fuel report views (full report + per-chat
 * dialog): selected day, prev/next navigation clamped at today, and the
 * day-window bounds handed to the detail dialog. Extracted so the two entry
 * points can't drift apart.
 */
export function useDayNavigation() {
  const [selectedDate, setSelectedDate] = useState(() => new Date())

  const goToPreviousDay = useCallback(() => {
    setSelectedDate((prev) => {
      const next = new Date(prev)
      next.setDate(next.getDate() - 1)
      return next
    })
  }, [])

  const goToNextDay = useCallback(() => {
    setSelectedDate((prev) => {
      const next = new Date(prev)
      next.setDate(next.getDate() + 1)
      if (next > new Date()) return prev
      return next
    })
  }, [])

  const isToday =
    format(selectedDate, "yyyy-MM-dd") === format(new Date(), "yyyy-MM-dd")

  const dayWindow = useMemo(() => {
    const start = new Date(selectedDate)
    start.setHours(0, 0, 0, 0)
    const end = new Date(selectedDate)
    end.setHours(23, 59, 59, 999)
    return { from: start.toISOString(), to: end.toISOString() }
  }, [selectedDate])

  return {
    selectedDate,
    setSelectedDate,
    goToPreviousDay,
    goToNextDay,
    isToday,
    dayWindow,
  }
}
